import { Mail, Phone } from "lucide-react";
import { RiLinkedinFill } from "react-icons/ri";
const TopBar = () => {
  return (
    <div className="relative z-40 bg-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-3 py-2 text-white text-[10px] sm:text-[11px] md:text-xs overflow-x-auto md:overflow-visible whitespace-nowrap justify-start md:justify-end">
          <div className="flex items-center gap-3 sm:gap-4 min-w-max">
            <a
              href="mailto:info@bsssonata.com"
              className="flex items-center gap-1.5 text-white hover:text-white/80 transition shrink-0"
            >
              <Mail size={12} />
              <span className="font-medium tracking-wide">
                info@bsssonata.com
              </span>
            </a>
            <a
              href="tel:080-2318-8389"
              className="flex items-center gap-1.5 text-white hover:text-white/80 transition shrink-0"
            >
              <Phone size={12} />
              <span className="font-medium tracking-wide">080-2318-8389</span>
            </a>
            <a
              href="tel:080-2977-8389"
              className="flex items-center gap-1.5 text-white hover:text-white/80 transition shrink-0"
            >
              <Phone size={12} />
              <span className="font-medium tracking-wide">080-2977-8389</span>
            </a>
            <a
              href="tel:0522-2334900"
              className="flex items-center gap-1.5 text-white hover:text-white/80 transition shrink-0"
            >
              <Phone size={12} />
              <span className="font-medium tracking-wide">0522-2334900</span>
            </a>
            <div className="flex items-center gap-2 pl-2 border-l border-white/20">
              <a
                href="https://in.linkedin.com/company/bss-microfinance-limited"
                target="_blank"
                rel="noreferrer"
                className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition text-white shrink-0"
              >
                <RiLinkedinFill size={13} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
